/* eslint-disable */
import React from 'react'
import List from './components/List'
import ItemOverlay from './components/ItemOverlay'
import LanguageOverlay from './components/LanguageOverlay'
import SettingsOverlay from './components/SettingsOverlay'
import TopBar from './components/TopBar'
import track from './utils/track'
import store from 'react-native-simple-store'
import platform from './utils/platform'
import { API_URL, PUSH_SERVER_KEY } from './config'
import {
  StyleSheet,
  Text,
  View,
  FlatList,
  NativeModules,
  AppState,
  Linking,
  SafeAreaView,
  Platform,
} from 'react-native'

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    margin: 'auto',
    boxShadow: '0 0 8px 1px #ccc',
    marginTop: 20,
    marginBottom: 20,
  },

  containerInner: {
    height: 'calc(100vh - 40px)',
    transform: [{
      translateX: 0
    }],
  },

  topbar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    backgroundColor: 'white',
    borderBottomWidth: 1,
  }
})

const SETTINGS_SCHEMA = {
  schemaVersion: 3,
  userId: '',
  languagesSelected: false,
  firstLaunch: true,
  advancedModeEnabled: false,
  reminderRequested: false,
  reminderEnabled: false,
  purchases: [],
  nightModeEnabled: false,
  languages: {
    original: '',
    translated: '',
    additional: 'none',
  },
  remote: {
    forceUpdate: false,
    inAppStoreReview: false,
    availableLanguagePairs: {},
  }
}

export default class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      item: {},
      items: [],
      categories: [],
      settings: SETTINGS_SCHEMA,
      history: {},

      showLanguageOverlay: false,
      showSettingsOverlay: false,
      showItemOverlay: false,

      firstItemView: true,
      settingsLoaded: false,
      itemOverlayAsDictionary: false,
    }
  }

  loadListing(originalLanguage, translatedLanguage, userId) {
    fetch(`${API_URL}/listing?originalLanguage=${originalLanguage}&translatedLanguage=${translatedLanguage}&userId=${userId}`).then(response => response.json())
      .then(response => {
        this.setState({
          items: response.data.items,
          categories: response.data.categories,
        })
      })
  }

  componentWillMount() {
    fetch(`${API_URL}/settings`)
      .then(response => response.json())
      .then(response => {
        this.setState({
          settingsLoaded: true,
          settings: {
            ...this.state.settings,
            remote: response.data
          }
        })
      })

    store.get('history').then((history) => {
      history = history || {}
      store.save('history', history)
      
      this.setState({ history })
    })

    store.get('settings').then(settings => {
      if (!settings) {
        const referrer = window.location.search.replace('?ref=', '') || document.referrer || ' '

        track('install', {
          referrer,
          ...platform.info(),
        })
      } else {
        settings.firstLaunch = false
      }

      // Migrate settings.
      if (!settings || !settings.schemaVersion) {
        settings = SETTINGS_SCHEMA
      }

      // From version 1 to version 2.
      // Added availableLanguagePairs.
      if (settings.schemaVersion == 1) {
        settings.schemaVersion = 2
        settings.remote.availableLanguagePairs = {}
      }

      // From version 2 to version 3.
      // Added purchases.
      if (settings.schemaVersion == 2) {
        settings.schemaVersion = 3
        settings.purchases = []
      }

      if (settings.languagesSelected) {
        this.loadListing(settings.languages.original, settings.languages.translated, settings.userId)
      }
      
      if (settings.nightModeEnabled) {
        document.body.classList.add('global__nightmode')
      }
      
      store.save('settings', settings)
      this.setState({
        settings,
        showLanguageOverlay: !settings.languagesSelected,
      })

      if (!settings.userId) {
        this.createUser({
          platform: 'web',
          uniqueId: platform.getUniqueId(),
        }, (userId) => {
          settings = this.state.settings
          settings.userId = userId

          store.save('settings', settings)
          this.setState({ settings })
        })
      } else {
        fetch(`${API_URL}/user/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: settings.userId,
            platform: 'web',
            uniqueId: platform.getUniqueId(),
            languages: {
              original: settings.languages.original,
              translated: settings.languages.translated,
            },
          })
        })
        .then((response) => response.json())
        .then((response) => {
          settings = this.state.settings
          settings.userId = response.data.userId
          settings.purchases = response.data.purchases

          store.save('settings', settings)
          this.setState({ settings })
        })
      }
    })
  }

  componentDidMount() {
    this.checkPushNotifications()
  }

  createUser(params, callback) {
    if (navigator.userAgent.match('Googlebot')) return

    fetch(`${API_URL}/user/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        platform: params.platform,
        uniqueId: params.uniqueId,
      })
    })
    .then((response) => response.json())
    .then((response) => {
      callback(response.data.userId)
    })
  }

  onSelected(item) {
    this.setState({
      item: item,
      showItemOverlay: true,
    })
  }

  checkPushNotifications() {
    if (!('serviceWorker' in navigator && 'PushManager' in window)) return

    navigator.serviceWorker.register('/service-worker.js').then((serviceWorker) => {
      serviceWorker.pushManager.getSubscription().then((subscription) => {
        if (!subscription && this.state.settings.reminderEnabled) {
          this.onEmit('disableReminder')
        }
      })
    })
  }

  enablePushNotifications(callback, settingsPrompt) {
    navigator.serviceWorker.register('/service-worker.js').then((serviceWorker) => {
      serviceWorker.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: PUSH_SERVER_KEY,
      }).then((subscription) => {
        callback(subscription)
      }).catch((error) => {
        settingsPrompt && window.alert('Enable notifications in settings')
      })
    })
  }

  onEmit(action, data = {}) {
    let settings

    switch(action) {
      case 'showSettingsOverlay':
        this.setState({
          showSettingsOverlay: true,
        })
      break

      case 'showDictionaryOverlay':
        this.setState({
          showItemOverlay: true,
          showStatusBar: false,
          itemOverlayAsDictionary: true,
          item: {
            id: 'dictionary',
            numberOfEpisodes: 1,
          },
        })
      break

      case 'showLanguageOverlay':
        this.setState({
          showLanguageOverlay: true,
        })
      break

      case 'updateSettings':
        store.save('settings', {
          ...this.state.settings,
          ...data
        })
      break

      case 'changeUserId':
        settings = {
          ...this.state.settings,
          userId: data.userId,
        }

        this.setState({ settings })
        store.save('settings', settings)
        this.loadListing(settings.languages.original, settings.languages.translated, settings.userId)
      break

      case 'languageSelection':
        settings = {
          ...this.state.settings,
          languagesSelected: true,
          languages: {
            original: data.original,
            translated: data.translated,
            additional: data.additional || this.state.settings.languages.additional,
          }
        }

        fetch(`${API_URL}/user/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: settings.userId,
            settings: {
              languages: {
                original: data.original,
                translated: data.translated,
              }
            }
          })
        })

        this.setState({ settings })
        store.save('settings', settings)
        this.loadListing(settings.languages.original, settings.languages.translated, settings.userId)
      break

      case 'enableAdvancedMode':
        settings = {
          ...this.state.settings,
          advancedModeEnabled: true,
        }

        fetch(`${API_URL}/user/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: settings.userId,
            settings: {
              advancedModeEnabled: true
            }
          })
        })

        this.setState({ settings })
        store.save('settings', settings)
      break

      case 'enableNightMode':
        settings = {
          ...this.state.settings,
          nightModeEnabled: true,
        }

        document.body.classList.add('global__nightmode')
        this.setState({ settings })
        store.save('settings', settings)
      break

      case 'disableNightMode':
        settings = {
          ...this.state.settings,
          nightModeEnabled: false,
        }

        document.body.classList.remove('global__nightmode')
        this.setState({ settings })
        store.save('settings', settings)
      break

      case 'enableReminder':
        settings = { ...this.state.settings, reminderRequested: true }
        this.setState({ settings })
        store.save('settings', settings)

        this.enablePushNotifications((subscription) => {
          settings = {
            ...this.state.settings,
            reminderEnabled: true,
          }

          fetch(`${API_URL}/user/enableReminder`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              subscription,
              userId: settings.userId,
              platform: 'web',
              uniqueId: platform.getUniqueId(),
            })
          })

          this.setState({ settings })
          store.save('settings', settings)
        }, data.settingsPrompt)
      break

      case 'disableAdvancedMode':
        settings = {
          ...this.state.settings,
          advancedModeEnabled: false,
        }

        fetch(`${API_URL}/user/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: settings.userId,
            settings: {
              advancedModeEnabled: false
            }
          })
        })

        this.setState({ settings })
        store.save('settings', settings)
      break

      case 'disableReminder':
        settings = {
          ...this.state.settings,
          reminderEnabled: false,
        }

        fetch(`${API_URL}/user/disableReminder`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: settings.userId,
            platform: 'web',
            uniqueId: platform.getUniqueId(),
          })
        })

        this.setState({ settings })
        store.save('settings', settings)
      break

      case 'purchase':
        settings = {
          ...this.state.settings,
          purchases: [...this.state.settings.purchases, {
            id: data.id
          }]
        }

        fetch(`${API_URL}/user/purchase`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: settings.userId,
            purchaseId: data.id,
            platform: 'web',
          })
        })

        this.setState({ settings })
        store.save('settings', settings)
      break
    }
  }

  render() {
    return (
      <View style={[styles.container, {width: this.state.showItemOverlay ? '100%' : '730px'}]}>
        <View style={styles.containerInner}>
          <View style={styles.topbar}>
            <TopBar emit={this.onEmit.bind(this)} />
          </View>

          {this.state.categories.length != 0 && this.state.settingsLoaded &&
            <List
              items={this.state.items}
              settings={this.state.settings}
              categories={this.state.categories}
              history={this.state.history}
              emit={this.onEmit.bind(this)}
              onSelected={this.onSelected.bind(this)}>
            </List>
          }

          {this.state.showLanguageOverlay &&
            <LanguageOverlay
              show={this.state.showLanguageOverlay}
              availableLanguagePairs={this.state.settings.remote.availableLanguagePairs}
              ableToClose={false}
              emit={this.onEmit.bind(this)}
              onClose={() => this.setState({showLanguageOverlay: false})}>
            </LanguageOverlay>
          }

          <SettingsOverlay
            show={this.state.showSettingsOverlay}
            availableLanguagePairs={this.state.settings.remote.availableLanguagePairs}
            languages={this.state.settings.languages}
            settings={this.state.settings}
            emit={this.onEmit.bind(this)}
            onClose={() => this.setState({showSettingsOverlay: false})}>
          </SettingsOverlay>
        </View>

        {this.state.showItemOverlay &&
          <ItemOverlay
            item={this.state.item}
            asDictionary={this.state.itemOverlayAsDictionary}
            settings={this.state.settings}
            languages={this.state.settings.languages}
            emit={this.onEmit.bind(this)}
            showReminderRequest={
              'serviceWorker' in navigator && 'PushManager' in window &&
              !this.state.settings.reminderRequested &&
              (!this.state.firstItemView || !this.state.settings.firstLaunch)
            }
            onClose={() => {
              this.setState({
                firstItemView: false,
                showItemOverlay: false,
                itemOverlayAsDictionary: false,
              })
            }}>
          </ItemOverlay>
        }
      </View>
    )
  }
}
